import { Card, Col, Row } from 'react-bootstrap';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import { useEffect, useState } from 'react';
import Button from 'components/base/Button';

import Badge from 'components/base/Badge';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import imageIcon from 'assets/img/th-each-ai/image-placeholder.webp';
import { Blog } from './components/DataDefinitions';


const Magazine = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Blogs.page_title'),
            url: '/community'
        },

        {
            label: t('Magazine.page_title'),
            active: true
        }
    ];
    const auth = useAuth();
    //type MapType = Map<string, string>;

    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [sponsoredBlogs, setSponsoredBlogs] = useState<Blog[]>([]);
    const [topics, setTopics] = useState<string[]>([]);

    const [languages, setLanguages] = useState<string[]>([]);


    //const [searchMap, setSearchMap] = useState<MapType>(new Map());
    const [loading, setLoading] = useState(false);


    const truncateText = (longText: string, maxLength: number = 100) => {
        const truncatedText =
            longText.length > maxLength ? longText.slice(0, maxLength) + '...' : longText;
        return truncatedText;

    };

    const fetchData = async (type: string) => {
        setLoading(true);
        await fetchBlogs(type);
        await fetchSponsoredBlogs(type);
        setLoading(false);
    };


    const fetchBlogs = async (type: string) => {
        try {
            const response = await apiClient.get(
                '/v1/blogs/type/' + type,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );

            setBlogs(response.data.blogs);
            setTopics(response.data.topics);
            // Extract languages
            const languages = response.data.blogs.map((blog: { lang: string; }) => blog.lang);

            // Get unique languages
            const uniqueLanguages = [...new Set<string>(languages)];
            setLanguages(uniqueLanguages);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchSponsoredBlogs = async (type: string) => {
        try {
            const response = await apiClient.get(
                '/v1/sponsored-blogs/type/' + type,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setSponsoredBlogs(response.data.blogs);
        } catch (error) {
            console.error('Error fetching sponsored blogs:', error);
        }
    };


    useEffect(() => {
        fetchData("magazine");
        fetchSponsoredBlogs("magazine");
    }, []);

    const sponsored_blogs = sponsoredBlogs.map((blog, index) => (
        <Col key={index} xs={4} sm={4} md={4} lg={4} className="my-col mb-4">
            <Card className="m-2">
                <div style={{
                    backgroundImage: (blog.picture ? `url("data:image/jpeg;base64, ${blog.picture}")` : imageIcon), height: '200px',
                    backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%'
                }}>
                </div>


                <Card.Body style={{ height: '15rem' }}>
                    <Card.Title className='fs-9'><Badge variant="phoenix" bg='danger'>{blog.topic}</Badge></Card.Title>
                    <Card.Title className='fs-8' style={{ height: '40px' }}>{truncateText(blog.title, 80)}</Card.Title>

                    <Card.Text style={{ height: '120px', overflowY: 'hidden' }}>
                        {truncateText(blog.description)}
                    </Card.Text>

                </Card.Body>
                <Card.Footer className='mt-1'>
                    <Button variant="primary" onClick={() => window.open(blog.url, '_blank')}>{t('Blogs.visit_url')}<FontAwesomeIcon
                        icon={faExternalLink}
                        className="px-1 fs-10"
                    />
                    </Button>
                </Card.Footer>
            </Card>
        </Col >
    ));


    const filtered_blogs = blogs.map((blog, index) => (
        <Col key={index} xs={3} sm={3} md={3} lg={3} className="my-col mb-4">
            <Card className="m-2">
                <div style={{
                    backgroundImage: (blog.picture ? `url("data:image/jpeg;base64, ${blog.picture}")` : imageIcon), height: '200px',
                    backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%'
                }}>
                </div>

                <Card.Body style={{ height: '15rem' }}>
                    <Card.Title className='fs-9'><Badge variant="phoenix" bg='danger'>{blog.topic}</Badge></Card.Title>
                    <Card.Title className='fs-8' style={{ height: '40px' }}>{truncateText(blog.title, 80)}</Card.Title>

                    <Card.Text style={{ height: '120px', overflowY: 'hidden' }}>
                        {truncateText(blog.description)}
                    </Card.Text>
                </Card.Body>
                <Card.Footer className='mt-1'>
                    <Button variant="primary" onClick={() => window.open(blog.url, '_blank')}>{t('Blogs.visit_url')}<FontAwesomeIcon
                        icon={faExternalLink}
                        className="px-1 fs-10"
                    /></Button>
                </Card.Footer>
            </Card>
        </Col>
    ));

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <Row className="p-4 theachai-overflow-x-scroll flex-nowrap">
                {sponsored_blogs.length > 0 && sponsored_blogs}
            </Row>

            <Row className='mt-2'>
                {filtered_blogs}
            </Row>

        </>
    );
};

export default Magazine;
